import "./singleroom.css";
import { useContextSelector } from "@fluentui/react-context-selector";
import { StoreContext } from "../../context";
import { Box } from "@material-ui/core";
import AmsProductList from "../../molecules/AmsProductList/AmsProductList";
import { useEffect, useState } from "react";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import AmsTypography from "../../atoms/AmsTypography/AmsTypography";
import AmsDivider from "../../atoms/AmsDivider/AmsDivider";
import { navigate, useLocation } from "@reach/router";
import { getMobileOperatingSystem } from "../../utils/helpers";
import { makeStyles } from "@material-ui/core/styles";
import MessageBlock from "../../molecules/MessageBlock/MessageBlock";
import { cubesheetData, roomMapObj } from "../../utils/cubeSheetList";


const useStyles = makeStyles({
  buttonContainer: {
    // padding: "4vw",
    // width: "92vw",
    background:
      "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%)",
    marginBottom: (props: any) => (props?.os === "iOS" ? "0px" : "0px"),
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  },
});

const SingleRoom = (props: any) => {
  const { btnProps, messageBlock,addItemBtnProps } = props?.templateProps;

  console.log(" Hello ", addItemBtnProps)
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  let currentRoom: any = search.get("room");
  let os: any = getMobileOperatingSystem();
  const classes = useStyles({ os: os });

  const [roomIndex, setRoomIndex] = useState(1);
  const [currRoom, setCurrRoom] = useState("");
  
  const customerContext: any = useContextSelector(
    StoreContext,
    (store) => store?.appState?.customerJourneyContext
  );

  const dispatch: any = useContextSelector(
    StoreContext,
    (store) => store?.dispatch
  );

  let rooms = customerContext?.rooms;

  //let rooms:any = sessionStorage.getItem("selectedRooms")
  //rooms = JSON.parse(rooms)
  let allRoomsInfo: any;
  let roomInfo = sessionStorage.getItem("roomInfo");
  if (roomInfo) {
    allRoomsInfo = JSON.parse(roomInfo);
  }

  useEffect(() => {
    setCurrRoom(currentRoom);
  }, [location.search]);

  useEffect(() => {
    let currRoomName = currRoom?.split("-").join(" ");
    const curRoomIndex =
      rooms.findIndex((item: any) => item?.room === currRoomName) + 1;

    console.log("Currr Room : ", currRoomName, curRoomIndex, rooms);

    if (curRoomIndex > 0) {
      setRoomIndex(curRoomIndex);
    } else {
      console.log("No room", customerContext?.rooms);
    }
  }, [currRoom]);

  const handleSubmit = () => {
    if (roomIndex < rooms.length) {
      let newIndex = roomIndex + 1;
      let nextRoom = rooms[roomIndex]["room"];
      nextRoom = nextRoom.replace(/\s/g, "-");
      //setRoomIndex(newIndex);
      navigate(`${btnProps?.sameScreen}?room=${nextRoom}`);
    } else {
      navigate(btnProps?.nextScreen);
    }
  };

  const Products = (props: any) => {
    let room = props?.products?.room;
    const allRoomsObject = allRoomsInfo.find((entry: any) => room in entry);
    console.log("Hii Product Details : ", room, allRoomsObject);

    return <AmsProductList list={allRoomsObject[`${room}`]} roomType={room}  currentRoom={currentRoom}/>;
  };

  console.log("Rooms : ", rooms, roomIndex - 1);
  

  return (
    <Box className="baseContainerBlock HomeBlock">
      <Box className="mainContainer">
        <Box style={{ marginBottom: "100px" }}>
          <Box className="title" mb={5}>
            <AmsTypography
              variant="h1"
              text={rooms[`${roomIndex - 1}`]["room"]}
            />
          </Box>
          <Box mb={5} mt={5}>
            <AmsDivider />
          </Box>
          <Products products={rooms[`${roomIndex - 1}`]} />
          <Box mb={5} mt={5} className="messageBlock">
            {messageBlock && <MessageBlock message={messageBlock?.text} />}
          </Box>
        </Box>
      </Box>
      <Box className="buttonContainerBlock">
        <Box className={classes.buttonContainer}>
          <AmsButton
            attributes={btnProps?.attributes}
            handleClick={handleSubmit}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SingleRoom;
